import { useCallback, useEffect, useState } from "react";
import { getUserInfo } from "../../reducers/userSlice";
import { useAppDispatch, useAppSelector } from "../../store/hook";
import MutilLanguage from "./comp/MutilLanguage";
import Cookies from "universal-cookie";
import { AuthConstant } from "../../constants/authConstant";
import { NotiService } from "../../services/noti/NotiService";
import { VariablesConstant } from "../../constants/variables";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import moment from "moment";
import NotificationItem from "../commons/NotificationItem";
import { useLocation, useNavigate } from "react-router-dom";
import { Constant } from "../../constants/constant";
import { Sys0301Service } from "../../services/sys/Sys0301Service";
import { useTranslation } from "react-i18next";

export default function Header() {
  const dispatch = useAppDispatch();
  const message = useSelector((state: any) => state.socket.message);
  const menus = useAppSelector((state:any) => state.menus.menus);
  const location = useLocation();
  const url = location.pathname;
  const [menuInf, setMenuInf] = useState<any>();
  const lang = useAppSelector((state:any) => state.language.lang)
  const userInfo = useAppSelector(state => state.userInfo.userInfo)
  const navigate = useNavigate();
  const {t} = useTranslation()
  
  useEffect(() => {
    dispatch(getUserInfo());
  }, []);

    const translateMenuNm = useCallback(
      (item: any) => {
        if (Constant.SOUTH_KOREA === lang) {
          return item.menuNm;
        } else if (Constant.ENGLISH === lang) {
          return item.menuNmEn;
        } else {
          return item.menuNmVi;
        }
      },
      [lang]
    );

  useEffect(()=>{    
    menus.forEach((item:any) => {
      if(url.includes(item.url)) {
        setMenuInf(item)
      }
    })
  },[menus, url])

  const cookies = new Cookies();

  const logout = () => {
    cookies.remove(AuthConstant.ACCESS_TOKEN);
    let domain = window.location.origin;
    window.location.href = process.env.REACT_APP_AUTH_URL + "/login?pre_action=logout&redirect_uri=" + domain || "";
  };

  const [listNoti, setListNoti] = useState<any>();
  const [notiUnread, setNotiUnread] = useState<any>();

  useEffect(() => {
    getListNoti();
  }, []);

  useEffect(() => {
  }, [userInfo]);

  useEffect(() => {
    if (message) {
      getListNoti();
      getNotiById(message);
    }
  }, [message]);

  const getListNoti = () => {
    NotiService.getInstance()
      .getNotiByUserUid()
      .then((res: any) => {
        setListNoti(res.data.result.responseData.listNoti);
        setNotiUnread(res.data.result.responseData.notiUnread);
      })
      .catch((err: any) => {});
  };

  const getNotiById = (id: any) => {
    NotiService.getInstance()
      .getNotiById({ notiId: id })
      .then((res) => {
        let resp = res.data.result.responseData;
        if (resp.notiTp === VariablesConstant.COLLECTION_INSTANCE_STOPPED) {
          let content = lang === Constant.ENGLISH ? `Collection instance of connection ${resp.connNm} has stopped` : `${resp.connNm} 연결의 컬렉션 인스턴스가 중지되었습니다`;
          toast.error(content);
        } else if (resp.notiTp === VariablesConstant.DELIVERY_INSTANCE_STOPPED) {
          let content = lang === Constant.ENGLISH ? `Delivery instance of connection ${resp.connNm} has stopped` : `${resp.connNm} 연결의 전달 인스턴스가 중지되었습니다`;
          toast.error(content);
        } else if (resp.notiTp === VariablesConstant.COLLECTION_CONNECT_KAFKA_FAILED) {
          let content = lang === Constant.ENGLISH ? `Collection instance of connection ${resp.connNm} can't connect to kafka` : `${resp.connNm} 연결의 컬렉션 인스턴스가 Kafka에 연결할 수 없습니다`;
          toast.error(content);
        } else if (resp.notiTp === VariablesConstant.DELIVERY_CONNECT_KAFKA_FAILED) {
          let content = lang === Constant.ENGLISH ? `Delivery instance of connection ${resp.connNm} can't connect to kafka` : `${resp.connNm} 연결의 딜리버리 인스턴스가 Kafka에 연결할 수 없습니다`;
          toast.error(content);
        } else if (resp.notiTp === VariablesConstant.COLLECTION_DEVICE_STOPPED) {
          let content = lang === Constant.ENGLISH ? `Collection instance of connection ${resp.connNm} can't connect to device` : `${resp.connNm} 연결의 컬렉션 인스턴스가 디바이스에 연결할 수 없습니다`;
          toast.error(content);
        } else {
          let content = lang === Constant.ENGLISH ? `Delivery instance of connection ${resp.connNm} can't connect to database` : `${resp.connNm} 연결의 딜리버리 인스턴스가 데이터베이스에 연결할 수 없습니다`;
          toast.error(content);
        }
      })
      .catch((err) => {});
  };

  const markAllRead = () => {
    NotiService.getInstance()
      .readAllNoti()
      .then((res) => {
        getListNoti();
      })
      .catch((err) => {});
  };

  return (
    <header className="main-header">
      <div className="d-flex align-items-center logo-box">
        <div onClick={() => navigate("/")} className="logo cursor-pointer">
          <div className="logo-lg">
            <span className="light-logo">
              <img src={require("../../../assets/images/logo.png")} alt="logo" />
            </span>
          </div>
        </div>
      </div>
      <nav className="navbar navbar-static-top">
        <h2 className="menu-name">{menuInf ? translateMenuNm(menuInf) : ""}</h2>
        <div className="app-menu">
          <ul className="header-megamenu nav">
            <li className="btn-group nav-item"></li>
          </ul>
        </div>

        <div className="navbar-custom-menu r-side">
          <ul className="nav navbar-nav">
            <li className="dropdown">
              <MutilLanguage />
            </li>
            <li className="dropdown notifications-menu">
              <a href="#" className="d-flex waves-effect waves-light dropdown-toggle btn-outline no-border" data-bs-toggle="dropdown" title="Notifications"
                style={{justifyContent: "center", borderRadius: "50%", backgroundColor: "white", padding: "0px", alignItems: "center"}}
              >
                <img src={require("../../../assets/images/icon/bell.png")} style={{width: "16px", height: "20px"}}></img>
              </a>
              {notiUnread !== 0 && <span className="position-absolute badge badge-pill badge-danger">{notiUnread < 10 ? notiUnread : "9+"}</span>}
              <ul className="dropdown-menu animated bounceIn">
                <li className="header">
                  <div className="p-20">
                    <div className="flexbox">
                      <div>
                        <h4 className="mb-0 mt-0">{t("header.noti.label.title")}</h4>
                      </div>
                      <div>
                        <a href="#" className="text-danger" onClick={markAllRead}>
                          {t("header.noti.label.maskAsAllRead")}
                        </a>
                      </div>
                    </div>
                  </div>
                </li>

                <div className="notification-wrap">
                  {listNoti &&
                    listNoti.map((ele: any, index: any) => (
                      <li key={index} className={"d-flex py-3 px-2 cursor-pointer " + (!ele.readYn ? "bg-alice-blue" : "")}>
                        <div className="col-lg-3 d-flex justify-content-center align-items-center">
                          <i className="pi pi-exclamation-circle fs-1 text-danger"></i>
                        </div>
                        <div className="col-lg-9 d-flex flex-column">
                          <div>
                            <NotificationItem {...ele}></NotificationItem>
                          </div>
                          <div className="text-end">{moment(ele.createdDt).format("YYYY/MM/DD, HH:mm:ss")}</div>
                        </div>
                      </li>
                    ))}
                </div>
              </ul>
            </li>

            <li className="dropdown user user-menu">
              <a className="d-flex waves-effect waves-light dropdown-toggle no-border w-auto" data-bs-toggle="dropdown" title="User"
                style={{background: "white", padding: "5px 10px 5px 10px", borderRadius: "20px"}}>
                <img className="avatar avatar-pill" src={require("../../../assets/images/avatar/3.jpg")} alt="" />
                <div style={{
                    paddingLeft: "10px",
                    height: "inherit",
                    display:"flex",
                    alignItems: "center",
                  }}>
                  <p className="fs-5 text-dark">{userInfo.fullName}</p>
                </div>
                
              </a>
              <ul className="dropdown-menu animated flipInX">
                <li className="user-body">
                  <a className="dropdown-item disabled">
                    <i className="pi pi-user text-muted me-2"></i> {t("header.user.label.profile")}
                  </a>
                  <a className="dropdown-item disabled">
                    <i className="pi pi-cog text-muted me-2"></i> {t("header.user.label.settings")}
                  </a>
                  <div className="dropdown-divider"></div>
                  <a className="dropdown-item" onClick={logout}>
                    <i className="pi pi-lock text-muted me-2"></i> {t("header.user.label.logout")}
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </nav>
    </header>
  );
}
